<template>
  <LoadingCard
    :loading="loading"
    class="p-3"
  >
    <p class="mb-2">{{ $t('Average time to resolution') }}</p>
    <h3
      class="text-5xl text-analytics-purple cursor-pointer font-museo"
      @click="$emit('numberClick')"
      v-html="formattedResolvedIn"
    ></h3>
  </LoadingCard>
</template>

<script>
  import LoadingCard from '@/_legacy/components/LoadingCard.vue';
  import ResolvedInDecoder from '@/_legacy/views/Analytics/decoders/ResolvedInDecoder';

  export default {
    name: 'TimeToResolutionCard',

    components: { LoadingCard },

    props: {
      loading: {
        type: Boolean,
        default: true,
      },
      data: {
        type: [String, Number],
        default: '',
      },
    },

    computed: {
      formattedResolvedIn() {
        return ResolvedInDecoder(parseInt(this.data, 10))
          .replace(/ /g, '<br>');
      },
    },

  };
</script>
